import { ComponentProps, useCallback, useContext, useMemo, useRef } from 'react';

import {
  ComponentType,
  LuiModalAsyncContext,
  openModalOnAllWindows,
  PromiseWithResolve,
  ShowModalProps,
} from './LuiModalAsyncContext';

export const useShowAsyncModal = () => {
  const { showModal } = useContext(LuiModalAsyncContext);

  // eslint-disable-next-line
  const modalOwnerRef = useRef<any>(document.body);

  const showModalAsync = useCallback(
    <CT extends ComponentType>(
      component: CT,
      args: Omit<ComponentProps<CT>, 'resolve' | 'close'>,
      props?: ShowModalProps,
    ): PromiseWithResolve<Parameters<ComponentProps<CT>['resolve']>[0]> =>
      showModal(props?.showOnAllWindows ? openModalOnAllWindows : modalOwnerRef, component, args, props),
    [showModal],
  );

  return useMemo(
    () => ({
      showModal: showModalAsync,
      modalOwnerRef,
    }),
    [showModalAsync],
  );
};
